// CU-86d45b2z1 — client for commerce's customer-safe catalogue; the projection carries no cost, SKU, Shopify or stock fields.
import { ENV } from "../../config/runtimeEnv";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_COMMERCE_SERVER;

export interface CustomerCatalogCategory {
	id: number;
	name: string;
}

export interface CustomerCatalogImage {
	id: number;
	file_id: string;
	position: number;
	is_primary: boolean;
	alt_text: string | null;
}

export interface CustomerCatalogVariant {
	variant_id: number;
	title: string | null;
	option1: string | null;
	option2: string | null;
	option3: string | null;
	// CU-86d45b2z1: commerce's decimal string, e.g. "45.00".
	price: string;
	is_default_variant: boolean;
	// CU-86d45b2z1: 0 is out of stock; the variant is still listed.
	available: number;
}

export interface CustomerCatalogProduct {
	product_id: number;
	name: string;
	description: string | null;
	category: CustomerCatalogCategory | null;
	images: CustomerCatalogImage[];
	variants: CustomerCatalogVariant[];
}

export interface CustomerCatalogPage {
	data: CustomerCatalogProduct[];
	categories: CustomerCatalogCategory[];
	pagination: {
		current_page: number;
		per_page: number;
		total_pages: number;
		total_items: number;
	};
}

export interface CustomerCatalogQuery {
	page?: number;
	perPage?: number;
	search?: string;
	categoryId?: number;
}

export const fetchCustomerCatalog = async ({
	page = 1,
	perPage = 24,
	search,
	categoryId,
}: CustomerCatalogQuery = {}): Promise<CustomerCatalogPage> => {
	const response = await http.get(`${API_BASE_URL}/customer/catalog/products`, {
		params: {
			page,
			per_page: perPage,
			...(search ? { search } : {}),
			...(categoryId ? { category_id: categoryId } : {}),
		},
	});

	return response.data;
};

// CU-86d45b2zn: the classifier now lives in customerAccess.ts so the order history shares it; the catalogue's names are kept.
export {
	CUSTOMER_ACCESS_FORBIDDEN,
	CUSTOMER_SESSION_REFRESH_REQUIRED,
	classifyCustomerAccessError as classifyCustomerCatalogError,
} from "./customerAccess";
export type { CustomerAccessOutcome as CustomerCatalogAccessOutcome } from "./customerAccess";
